define('../src/sublayouts/m7-middle-title/m7-middle-title',['jquery'], function ($) {

    'use strict';

    var M7_MIDDLE_TITLE = function ($component) {

        this.$component = $component;

        return this;
    };

    M7_MIDDLE_TITLE.prototype.init = function () {

        var title = $('.m7-middle-title'),
            windHeight,
            windHeight = $(window).height() / 2 - 245;


            title.css('margin-top', windHeight)
            
             if( windHeight >= 40){
                    title.css('margin-top', windHeight)
                }
                 if( windHeight < 40){
                     title.css('margin-top', 40)
                 }
            

       $(window).on('resize', function(){

            var title = $('.m7-middle-title'),
                windHeight,
                windHeight = $(window).height() / 2 - 245;


                if( windHeight >= 40){
                    title.css('margin-top', windHeight)
                }
                 if( windHeight < 40){
                     title.css('margin-top', 40)
                 }
            

        });
        

    }


    return M7_MIDDLE_TITLE;

});
